// extracted by mini-css-extract-plugin
module.exports = {"boxTime":"TwoFactor_boxTime_GpbfF","authbox":"TwoFactor_authbox_2C4oW","texth1":"TwoFactor_texth1_1cUD6"};